import { action, observable } from 'mobx';
import { api, config} from '../config';



// Helpers
import { formatQuery } from '../helpers';

// AppStore (used for loading, error throwing, etc.)
import AppStore from './AppStore';

// UserStore (used to access user data)
import UserStore from './UserStore';

let obx = observable({
  assessments: [],
  assessmentsNext: null,
  submissionConfirmation: true,

  /**
   * listGroupAssessments - Gets all assessments for a given group
   * @param {string} assessmentGroupSid
   * @param {object} query
   * @param {function} callback
   */
  listGroupAssessments: action((assessmentGroupSid, query, callback) => {
    AppStore.startLoading('listGroupAssessments');

    const url = `/installs/${UserStore.installSid}/assessmentGroups/${assessmentGroupSid}${formatQuery(query)}`;

    api
      .get(url)
      .then(response => {
        obx.assessments = response.data.items;

        if (callback) {
          callback(response.data.items);
        }

        AppStore.finishLoading('listGroupAssessments');
      })
      .catch(error => {
        AppStore.throwError(error);
      });

    return obx.assessments;
  }),

  /**
   * getAssessment
   * @param {string} assessmentSid
   * @param {object} query
   */
  assessment: null,

  getAssessment: action((assessmentSid, query, backgroundLoad, callback) => {
    if(!backgroundLoad) {
      AppStore.startLoading('getAssessment');
    }

    const url = `/installs/${UserStore.installSid}/assessments/${assessmentSid}${formatQuery(query)}`;

    api.get(url)
      .then(response => {
        obx.assessment = response.data;

        if(response.data.submissionConfirmation !== null){
          obx.submissionConfirmation = response.data.submissionConfirmation;
        }

        if(callback) {
          callback(response.data);
        }

        if(!backgroundLoad) {
          AppStore.finishLoading('getAssessment');
        }
      })
      .catch(error => {
        AppStore.throwError(error);
      });
  }),

  /**
   * listAttempts
   * @param {object} query
   * @param {function} callback
   */
  attempts: [],

  listAttempts: action((query, callback) => {
    AppStore.startLoading('listAttempts');

    const url = `/installs/${UserStore.installSid}/attempts${formatQuery(query)}`;

    api
      .get(url)
      .then(response => {
        obx.attempts = response.data.results;

        if (callback) {
          callback(obx.attempts);
        }

        AppStore.finishLoading('listAttempts');
      })
      .catch(error => {
        AppStore.throwError(error);
      });
  }),

  /**
   * getAttempt
   * @param {string} attemptSid
   */
  attempt: null,

  getAttempt: action((attemptSid, callback) => {
    AppStore.startLoading('getAttempt');

    const url = `/installs/${UserStore.installSid}/attempts/${attemptSid}`;

    api
      .get(url)
      .then(response => {
        obx.attempt = response.data;

        if (callback) {
          callback(obx.attempt);
        }

        AppStore.finishLoading('getAttempt');
      })
      .catch(error => {
        AppStore.throwError(error);
      });

  }),

  getNextRoute: action((data, history) => {

  const appInstallSid = UserStore?.installSid || null;
  if(data.routing){
    const {type, value} = data.routing.next;

    switch(type){
      case "assessmentGroupHome":
        //TODO: Fix routes in another ticket to assign group home to something such as /groups/:groupSid instead of public start being there
        history.push('/')
        break;
      case "report":
        //TODO: report routing currently returns a reportSid we will need to make some changes to the report page to make this work
        if (appInstallSid && config.customRedirectInstalls.includes(appInstallSid)) {
          history.push(`/report/intro?hideNotification=true`);
        } else {
          history.push(`/report/${UserStore.userData.userSid}`)
        }
        break;
      case "assessment":
        history.push('/')
        history.replace(`/assessment/${value.assessmentSid}?groupItem=${value.groupItemSid}`)
        break;
      default:
        break;
      }
    }
  }),

  /**
   * createAttempt
   * @param {object} payload
   * @param {function} callback
   */
  attemptSid: null,

  createAttempt: action((payload, callback) => {
    AppStore.startLoading('createAttempt');

    const url = `/installs/${UserStore.installSid}/attempts`;

    api
      .post(url, payload)
      .then(response => {
        obx.attempt = response.data[0];
        obx.attemptSid = response.data[0].attemptSid;

        if (callback) {
          callback(obx.attemptSid);
        }

        AppStore.finishLoading('createAttempt');
      })
      .catch(error => {
        AppStore.throwError(error);
      });
  }),

  /**
   * saveAttempt
   * @param {string} attemptSid
   * @param {object} payload
   * @param {function} callback
   * @param {boolean} backgroundLoad
   */
  saveAttempt: action((attemptSid, payload, callback, backgroundLoad) => {
    if (!backgroundLoad) {
      AppStore.startLoading('submitAssessment');
    }
    if(payload.finalSubmission){
      console.log("Saving Attempt", payload)
    }

    const url = `/installs/${UserStore.installSid}/attempts/${attemptSid}`;

    api
      .put(url, payload)
      .then(response => {
        if (callback) {
          callback(response.data);
        }
        if(payload.finalSubmission){
          console.log("Response:", response)
        }

        if (!backgroundLoad) {
          AppStore.finishLoading('submitAssessment');
        }
      })
      .catch(error => {
        // TEMP: Placeholder complete button
        // is throwing an error so we’re ignoring it
        // until we actually hook this stuff up
        // AppStore.throwError(error);

        if (callback) {
          callback();
        }
        if(payload.finalSubmission){
          console.log('Error saving attempt', error, attemptSid)
        }

        if (!backgroundLoad) {
          AppStore.finishLoading('submitAssessment');
        }
      });
  }),

  provisionAssessment: action(async (payload, callback) => {
    AppStore.startLoading('provisionAssessment');

    const url = `/installs/${UserStore.installSid}/provision`;

    api.post(url, payload)
      .then(response => {
        if (response.data.result === 'assessment-provisioned') {
          // redirect to url
          AppStore.finishLoading('provisionAssessment');

          window.location = response.data.redirectUrl;
        } else if (response.data.result === 'user-already-exists') {
          AppStore.finishLoading('provisionAssessment');
          
          if (callback) {
            callback(response.data.result)
          };
        } else {
          throw new Error('an unexpected error occurred');
        }
      })
      .catch(error => {
        AppStore.throwError(error);
      })
  })
});

export default obx;
